import { type PaginatedQueryParams } from 'queries/queries-utils'

interface MutateStatusCheckParams {
  statusCheckId: string
  teamId: string
}

export const statusChecksQueryKeys = {
  all: (teamId: string) => ['status-checks', { teamId }] as const,
  allForCompany: (params: PaginatedQueryParams) =>
    ['status-checks/all-for-company', params] as const,
  service: (serviceId: string, params: { teamId: string }) =>
    [`services/${serviceId}/status-checks`, params] as const
}

export const statusChecksMutationKeys = {
  createDynatraceStatusCheck: (params: { teamId: string }) =>
    ['dynatrace/status-checks', params] as const,
  createStatusCheck: (teamId: string) => ['status-checks', { teamId }] as const,
  mutateDynatraceStatusCheck: ({
    statusCheckId,
    ...params
  }: MutateStatusCheckParams) =>
    [`dynatrace/status-checks/${statusCheckId}`, params] as const,
  mutateStatusCheck: ({ statusCheckId, ...params }: MutateStatusCheckParams) =>
    [`status-checks/${statusCheckId}`, params] as const,
  runTestEndpoint: (teamId: string) =>
    ['status-checks/run-test-endpoint', { teamId }] as const,
  runTestEvaluation: (teamId: string) =>
    ['status-checks/run-test-evaluation', { teamId }] as const
}

export const preFlightMutationKeys = {
  dynatrace: (teamId: string) => ['dynatrace/pre-flight', { teamId }] as const
}
